import { render } from "./Chapter3.vue?vue&type=template&id=a0d1ebea"
import script from "./Chapter3.vue?vue&type=script&lang=js"
export * from "./Chapter3.vue?vue&type=script&lang=js"

import "./Chapter3.vue?vue&type=style&index=0&id=a0d1ebea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__